import { sendExtensibleRequest } from '../../lib-alme-request/src/lib-alme-request';
import {DefaultSettings} from "../../../settings/settings-util";
import {Store} from "redux";
import {AlmeState} from "../../../wireup/AlmeState";
import LiveChatState from "./livechat-state";
import {AlmeUIInput} from "../../../types/input";
import {AlmeUIResponseArray, Message} from "../../../types/response";


export default class LiveChatRetriever
{

    _settings: DefaultSettings;
    _store: Store<AlmeState> | null = null;
    _state: LiveChatState;


    //#region Public Interface

    constructor(settings: DefaultSettings, state: LiveChatState)
    {
        this._settings = settings;
        this._state = state;
    }

    initialize(store: Store<AlmeState>): void
    {
        this._store = store;
    }

    async asyncRetrieveMessages(): Promise<AlmeUIResponseArray>
    {
        if (!this._state.sessionId) { return []; }

        const request = this.createRequest();
        const responseAsync = await sendExtensibleRequest(request, 'GET');
        const messages = (responseAsync as Message)?.response as AlmeUIResponseArray;

        return messages ?? [];
    }

    //#endregion



    //#region Helper Methods

    createRequest(): AlmeUIInput
    {
        // TODO: Change endpoint once backend component implemented
        const { Base, LastSeenIndex } = this._settings.stateLocations.LiveChat;
        const endpoint = this._settings.ExtensibleAlmeAPI.notificationsApi;
        const _lastSeenIndex = this._store?.getState()[Base][LastSeenIndex];
        const url = `${endpoint}?sessionId=${this._state.sessionId}&index=${_lastSeenIndex + 1}`;

        return {
            endpoint: url,
            messageType : this._settings.messageConstants.notificationType,
            messageSource : this._settings.livechat.messageSourceConstants.getNotifications,
        };
    }

    //#endregion
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/livechat-foundation/src/livechat-retriever.ts